import { useState } from "react";

import PasswordResetStep1 from "~/components/password-reset/password-reset-step-1";
import PasswordResetStep2 from "~/components/password-reset/password-reset-step-2";
import { ActionCodeContextProvider } from "~/contexts/action-code-context-provider";

enum PasswordResetSteps {
  Step1 = "Step1",
  Step2 = "Step2",
}

export default function ActionCodePasswordResetForm() {
  const [currentStep, setCurrentStep] = useState(PasswordResetSteps.Step1);
  const [email, setEmail] = useState("");

  const goToNextStep = (newEmailValue: string) => {
    setEmail(newEmailValue);
    setCurrentStep(PasswordResetSteps.Step2);
  };

  const goToPrevStep = () => {
    setCurrentStep(PasswordResetSteps.Step1);
  };

  const steps = {
    [PasswordResetSteps.Step1]: <PasswordResetStep1 onNext={goToNextStep} />,
    [PasswordResetSteps.Step2]: <PasswordResetStep2 onPrev={goToPrevStep} email={email} />,
  };

  return (
    <ActionCodeContextProvider>
      <div>{steps[currentStep]}</div>
    </ActionCodeContextProvider>
  );
}
